import $ from 'jquery';

export default function infinite() {
  
  function init() {
    var infinite = new Waypoint.Infinite({
      element: $('.infinite-container')[0]
    });
  }
  
  $( document ).ready(function() {
    if($('.infinite-container').length > 0) {
      init();
    }
  });
  
}


// WEBPACK FOOTER //
// ./src/assets/js/infinite-scroll.js